// extracted by mini-css-extract-plugin
export var configurationSection = "_ru-0";